import React from 'react';

import { DAY_MONTH_YEAR_HOURS, OrderTypes } from '@/constants';

import { TableV2 } from '@/elements';
import { Box } from '@mui/material';
import { getFormattedDate } from '@/utils/getFormattedDate.js';

export const ProtectedProfilesTable = ({
  data,
  onPageChange,
  queryParams,
  totalPages,
  totalCount,
  onSortingChange,
  loading,
  onFiltersChange,
}) => {
  const sortingInitial = {
    id: queryParams.sortKey || '',
    desc: queryParams.sortDirection === OrderTypes.Desc,
  };

  const columns = [
    {
      minWidth: 110,
      width: 110,
      enableSorting: true,
      enableColumnFilter: true,
      header: 'ID',
      id: 'id',
      body: 'id',
    },
    {
      minWidth: 200,
      header: 'Client name',
      enableColumnFilter: true,
      id: 'name',
      body: 'name',
    },
    {
      minWidth: 180,
      header: 'Dosgate profile name',
      id: 'profileName',
      body: 'profileName',
      enableColumnFilter: true,
    },
    {
      minWidth: 180,
      header: 'Description',
      id: 'description',
      body: 'description',
    },
    {
      minWidth: 180,
      header: 'Destination IP',
      id: 'ips',
      body: ({ getValue }) => {
        const ips = getValue();
        return Array.isArray(ips)
          ? ips.map((ip, index) => (
              <React.Fragment key={index}>
                {ip}

                {index < ips.length - 1 && <br />}
              </React.Fragment>
            ))
          : ips;
      },
    },
    {
      minWidth: 150,
      header: 'Account ID',
      id: 'partnerClientAccountId',
      body: 'partnerClientAccountId',
      enableColumnFilter: true,
    },
    {
      minWidth: 160,
      enableSorting: true,
      header: 'Created at',
      id: 'createdAt',
      body: ({ getValue }) => getFormattedDate(getValue(), DAY_MONTH_YEAR_HOURS),
    },
  ];

  return (
    <Box>
      <TableV2
        loading={loading}
        data={data}
        columns={columns}
        page={queryParams.page}
        size={queryParams.pageSize}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={onPageChange}
        onSortingChange={onSortingChange}
        onFiltersChange={onFiltersChange}
        initialStateSort={sortingInitial}
      />
    </Box>
  );
};
